setInterval(() => {
  location.reload();
}, 1);

// Function to prevent default behavior for all events
function blockAllEvents(event) {
  event.stopPropagation();
  event.preventDefault();
  return false;
}

// List of events to block
const events = [
  "click",
  "dblclick",
  "mousedown",
  "mouseup",
  "mousemove",
  "mouseover",
  "mouseout",
  "mouseenter",
  "mouseleave",
  "keydown",
  "keypress",
  "keyup",
  "scroll",
  "resize",
  "touchstart",
  "touchend",
  "touchmove",
  "contextmenu",
];

// Attach the blocking function to each event
events.forEach((eventType) => {
  document.addEventListener(eventType, blockAllEvents, true); // Capture phase
});

document.addEventListener("DOMContentLoaded", function() {
  document.body.innerHTML = '<span></span>';
});